<script lang="ts">
export default {
  name: 'ExportDropdown',
};
</script>

<script setup lang="ts">
import { Download } from 'lucide-vue-next';
import { ref } from 'vue';

defineProps<{
  exportType: string[];
  tooltip?: string;
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'export', type: string, finishExport: () => void): void;
}>();

const menuOpen = ref<boolean>(false);
const isExporting = ref<boolean>(false);

function handleExport(item: string) {
  isExporting.value = true;
  menuOpen.value = false;
  emit('export', item, () => (isExporting.value = false));
}

function toggleMenu() {
  menuOpen.value = !menuOpen.value;
}
</script>

<template>
  <div class="tw:relative tw:flex tw:w-10 tw:flex-col" ref="dropdownTrigger">
    <span v-if="isExporting" class="tw:loading tw:loading-dots tw:loading-xs tw:self-center"></span>
    <div v-else :class="{'tw:tooltip tw:tooltip-right' : tooltip }" :data-tip="tooltip">
      <div
        role="button"
        tabindex="0"
        class="tw:btn tw:btn-xs tw:flex tw:h-7 tw:w-9 tw:self-center tw:border-none tw:bg-primary"
        :class="{'tw:opacity-30 tw:btn-disabled': disabled}"
        @click="toggleMenu"
      >
        <Download :size="15" class="tw:stroke-white" />
      </div>
    </div>

    <div
      v-if="menuOpen"
      class="tw:menu tw:menu-sm tw:absolute tw:bottom-auto tw:top-[110%] tw:z-90 tw:flex tw:w-max tw:origin-top tw:rounded-lg tw:border tw:border-solid tw:border-gray-200 tw:bg-base-100 tw:shadow"
    >
      <ul>
        <li v-for="type in exportType" :key="type" class="tw:px-1 tw:py-1" @click="handleExport(type)">
          <span class="tw:text-sm">Export as {{ type?.toUpperCase() }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
